import { useState } from "react";
import { apiUrl } from "../utils/api";

const REPORT_QUESTION_API_URL = process.env.REACT_APP_REPORT_QUESTION_API_URL
    || apiUrl("report_question.php");

export default function QuizQuestion({
    quizId,
    question,
    language,
    isLastQuestion,
    onAnswer,
    onNext,
    text,
}) {
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [reportStatus, setReportStatus] = useState("idle");
    const options = question.Options;
    const questionText = question.Question;

    const handleAnswer = (option) => {
        if (selectedAnswer !== null) {
            return;
        }

        setSelectedAnswer(option);
        onAnswer(option);
    };

    const reportIncorrectAnswer = async () => {
        setReportStatus("sending");
        try {
            const response = await fetch(REPORT_QUESTION_API_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ quizId, questionId: question.id })
            });
            const result = await response.json();
            if (!response.ok) {
                throw new Error(result.error || `Report API returned HTTP ${response.status}`);
            }
            setReportStatus("sent");
        } catch (error) {
            console.error("Failed to report quiz question:", error);
            setReportStatus(error.message === "already_reported" ? "sent" : "error");
        }
    };

    return (
        <div className="quiz-body" dir={language === "ar" ? "rtl" : "ltr"}>
            <h2>{questionText}</h2>
            <div className="quiz-report-control">
                {reportStatus === "sent" ? (
                    <p role="status">{text.questionReportSent}</p>
                ) : (
                    <>
                        <button
                            className="quiz-report-btn"
                            type="button"
                            disabled={reportStatus === "sending"}
                            onClick={reportIncorrectAnswer}
                        >
                            {reportStatus === "sending"
                                ? text.questionReportSending
                                : text.reportWrongAnswer}
                        </button>
                        {reportStatus === "error" && (
                            <p className="quiz-report-error" role="alert">
                                {text.questionReportError}
                            </p>
                        )}
                    </>
                )}
            </div>
            <div className="quiz-options">
                {options.map((option, index) => {
                    const isSelected = selectedAnswer === option;
                    const isCorrect = option === question.CorrectAnswer;
                    let optionClassName = "answer-option";

                    if (selectedAnswer !== null) {
                        if (isCorrect) {
                            optionClassName += " correct-answer";
                        } else if (isSelected) {
                            optionClassName += " wrong-answer";
                        } else {
                            optionClassName += " disable-answer";
                        }
                    }

                    return (
                        <button
                            key={`${question.id}-${index}`}
                            type="button"
                            className={optionClassName}
                            onClick={() => handleAnswer(option)}
                            disabled={selectedAnswer !== null}
                            aria-pressed={isSelected}
                        >
                            {option}
                        </button>
                    );
                })}
            </div>
            <div className="quiz-footer">
                <button
                    className="quiz-btn"
                    onClick={onNext}
                    disabled={selectedAnswer === null}
                >
                    {isLastQuestion ? text.seeResults : text.next}
                </button>
            </div>
        </div>
    );
}
